import { AfterViewChecked, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { TableSection } from 'src/app/model/shared/table-section';
import { documentToHtmlString } from '.';

@Component({
  selector: 'app-offline-airline-profile-table-section',
  templateUrl: './offline-airline-profile-table-section.component.html',
  styleUrls: ['./offline-airline-profile-table-section.component.scss']
})
export class OfflineAirlineProfileTableSectionComponent implements OnInit, AfterViewChecked  {
  @Input() tableSections: TableSection[] = [];

  @ViewChild('modal') modal!: ModalComponent;

  eventListenersAdded: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.modal && this.modal.close();
    this.eventListenersAdded = false;
  }

  ngAfterViewChecked(): void {
    let elements = (<HTMLElement>this.elementRef.nativeElement).querySelectorAll('.xmlModal');

  

    if (elements.length > 0 && !this.eventListenersAdded) {
      this.eventListenersAdded = true;

      elements.forEach((element) =>
        this.renderer.listen(element, 'click', () => {
          this.modal.open(element.getAttribute('title') || '');
        })
      );
    }
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

}
